<template>
  <div class="disponibilidad" style="background-color:#ffffff; border-radius: 20px;">
    <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#064dc3" size="120" :is-full-screen="true" text="Cargando..." />
    <div class="form-row">
      <h1 class="col-9">Reporte de Unidades con Lectora</h1>
      <div class="col-2"></div>
      <router-link to="/home">
        <b-button variant="outline-success" style="margin: 10px">
          <div class="h6 mb-1">
            <b-icon-arrow-left-square></b-icon-arrow-left-square>
          </div>
          <div style="font-size: 12px;">
            Inicio
          </div>
        </b-button>
      </router-link>
    </div>
    <div class="row">
      
    </div>
    <div class="col-12">
        <label class="col-form-label">Tipo de lectora</label>
        <select name="selectGruposSitios" type="text" class="form-control" v-model="eventos">
         <option selected value="1">Todas</option>
         <option value="2">RF</option>
         <option value="3">QR</option>
         <option value="4">CB</option>                               
       </select>
      </div>
    <button class="btn btn-sm btn-primary mt-3" @click="generarReporte()">Generar reporte</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportExcel()">Exportar Excel</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportCSV()">Exportar CSV</button>
    <div class="table-responsive mt-4">
      <table class="table table-bordered table-hover text-center">
        <thead style="background-color: #05123C;">
          <tr class="text-white">
            <th>Id</th>
            <th>Unidad</th>
            <th>Lectora</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) of datosReporte">
            <td>{{ index+1 }}</td>
            <td>{{ item.nombre }}</td>
            <td>{{ item.lectora }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>

export default {
  data() {
    return {
      datosReporte: [],
      eventos:'1',
      loading:false

    }
  },
  
  methods: {
    generarReporte() {
      this.loading = true;
      axios.post(`${url2}unidadeslectora`,{'tipo_lectora' : this.eventos})
        .then(response => {
          this.datosReporte = response.data.datos;
          this.loading = false;
          console.log(this.eventos);
          
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.loading = false;
        });
    },

    formatearDatos() {          
     return this.datosReporte;
                         
    },

    exportExcel() {
			if(this.datosReporte){

        let data = XLSX.utils.json_to_sheet(this.datosReporte);
				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte Unidades con Lectora';
				XLSX.utils.book_append_sheet(workbook, data, filename);
      //  XLSX.writeFile(workbook, `${filename}.csv`);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },
    exportCSV() {
			if(this.datosReporte){

        let data = XLSX.utils.json_to_sheet(this.datosReporte);
				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte Unidades con Lectora';
				XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.csv`);
       // XLSX.writeFile(workbook, `${filename}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },

    
  },
  
}
</script>
<style>
  .disponibilidad{
    margin: 50px;
    margin-bottom:1%;
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    padding-top:15px;
  }
</style>